import gql from 'graphql-tag';

const query = gql`
  query MealReplacements(
    $userDietSetId: Int!
    $mealType: Int!
    $dietMealId: Int!
    $limit: Int!
    $prependWithOriginalMeal: Boolean
    $text: String
  ) {
    me {
      id
      dailyDietMeal(userDietSetId: $userDietSetId, mealType: $mealType, dietMealId: $dietMealId) {
        id
        key
        replacements(
          limit: $limit
          prependWithOriginalMeal: $prependWithOriginalMeal
          text: $text
        ) {
          id
          dishes {
            id
            name
            ingredients {
              name
              productId
            }
          }
          preparationImageUrl
          preparationTime {
            minutes
          }
          kcal
          publicName
          isFavorited
          diabeticDetails {
            assimilableCarbohydrate
            carbohydrateUnit
            fatProteinUnit
          }
          mealCustomTag {
            label
            color
          }
          rating {
            averageRating {
              averageRating
            }
          }
        }
      }
    }
  }
`;

export default query;
